module.exports = __webpack_public_path__ + "static/media/face-8.c5b81430.jpg";